module.exports = __webpack_public_path__ + "static/img/05.d5a342b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt2/05.png
// module id = w2p9
// module chunks = 1